import noop from 'utils/noop';
import { TAG_SIZES, TagSize } from '../constants';
import { Tag } from '../Tag';
import { TagGroupContentWrapper } from '../Tags.styles';
import { AddTag, EditTag, RemainderTag } from './SpecialTags';
import { TagOption, VisibleTagGroupOption } from '../types';

export interface TagListProps {
  /** Is "Add Tag" shown? */
  displayAddTag?: boolean;
  /** Is "Edit Tag" shown? */
  displayEditTag?: boolean;
  /** Are there remainder tags? */
  displayRemainderTag?: boolean;
  /** Is this in edit mode? */
  isInEditMode?: boolean;
  /** The tags not in view */
  remainderTags?: TagOption[];
  /** The size of the tags */
  tagSize?: TagSize;
  /** A list of all the visible tags */
  visibleTags?: VisibleTagGroupOption[];
  /** callback when entering edit mode */
  onEnterEditMode?: () => void;
  /** callback when removing a tag */
  onRemoveTag?: (tag: string) => void;
}

export const TagList = ({
  displayAddTag = false,
  displayEditTag = false,
  displayRemainderTag = false,
  isInEditMode = false,
  remainderTags = [],
  tagSize = TAG_SIZES.SMALL,
  visibleTags = [],
  onEnterEditMode = noop,
  onRemoveTag = noop,
}: TagListProps) => {
  const handleTagClick = (tag: TagOption) => {
    if (isInEditMode) {
      onRemoveTag(tag);
    }
  };

  return (
    <TagGroupContentWrapper data-test="tag-group-content-wrapper">
      {visibleTags.map(({ text, prefix, maxWidth } = {} as VisibleTagGroupOption) => (
        <Tag
          size={tagSize}
          text={text}
          key={text}
          prefix={prefix}
          maxWidth={maxWidth}
          isRemovable={isInEditMode}
          onRemove={() => handleTagClick(text)}
        />
      ))}
      {displayRemainderTag && <RemainderTag size={tagSize} tags={remainderTags} />}
      {displayAddTag && <AddTag size={tagSize} onClick={onEnterEditMode} />}
      {displayEditTag && <EditTag size={tagSize} onClick={onEnterEditMode} />}
    </TagGroupContentWrapper>
  );
};
